<div class="flxClmn">
    <div class="page-title-container flxRow">
        <div class="flxClmn-center f-1-0">
            <div class="page-title-inner-container flxRow">
                <span class="page-title">Mailbox Management</span>
                <!--Information modal-->
                <more-info-c>
                    <div class="flxClmn vSpace05" style="flex: 1 0;">
                        <span style="font-weight: bold;">Actions</span>
                        <br/>
                        <span><b>Enable API Protection</b> - enable Inbound Shield protection for this mailbox</span>
                        <span style="vertical-align: middle;"><b>Disable API Protection</b> - disable Inbound Shield protection for this mailbox</span>
                    </div>
                    <div class="flxClmn vSpace05" style="flex: 1 0;">
                        <span style="font-weight: bold;">Status</span>
                        <br/>
                        <span><b style="color: green;">Protected</b> - Emails sent to this mailbox are being scanned by Inbound Shield</span>
                        <span style="vertical-align: middle;"><b style="color: red;">Exposed</b> - Emails sent to this mailbox are currently not being scanned by Inbound Shield</span>
                        <span style="vertical-align: middle;"><b style="color: red;">Inactive</b> - Emails sent to this mailbox have not been scanned by Inbound Shield in the past 45 days</span>
                    </div>
                </more-info-c>
            </div>
            <div class="page-subtitle-container" style="display: flex; gap: 5px;">
                <span class="page-subtitle">Protect and manage the mailboxes on your mail server</span>
                <span style="background: var(--ui-surface-2); border-radius: 999px; padding: 2px 10px; font-size: 12px; font-weight: 600; color: var(--ui-text); margin-left: 8px; white-space: nowrap;"
                      [ngClass]="{'d-none' : protectedUsersCount || threatProtectionAllowedUsers}"
                      *ngIf="isLoaded">{{protectedUsersCount || 0}} of {{threatProtectionAllowedUsers || 0}} licenses used
                </span>
            </div>
        </div>
        <div class="control-and-info-icons flxRow"></div>
    </div>

    <div class="page-inner-content-holder no-scroll flxClmn" id="sharedplanactiveMobile">
        <!-- CONTENT : Loader -->
        <div *ngIf="!isLoaded" style="align-items: center; flex:1 0;" class="animated fadeIn flxClmn-center">
            <loader height="100" width="100" style="opacity: 0.8;"></loader>
        </div>

        <div *ngIf="isLoaded && !mailServerConnected">
            <div style="text-align: center; margin: 0 auto; width:70%;">
                <i style="opacity:0.4;" class="zmdi zmdi-hc-4x"></i>
                <h1 style="opacity:0.4; font-size: 50px;">Inbound Shield is disabled</h1>
                <span>You can enable Inbound Shield using the Email Server API Connection or the Inbound Email Relay from the <a style="font-weight: bold;" (click)="goToPlanSettingsPage();">Plan Settings</a> page</span>
                <br/>
                <hr/>
                <btn-c style="margin: auto;"
                     (action)="goToPlanSettingsPage();">
                    Plan Settings
                </btn-c>
            </div>
        </div>

        <!-- CONTENT : Mailboxes table + buttons -->
		<trustifi-table-c
			#mailboxesTable
			*ngIf="isLoaded && mailServerConnected"
			class="trustifi-table bs-enabled animated fadeIn" style="flex: 1 0; z-index: 5;"
			[list]="activeMailboxList"
			[headers]="_.compact([
				mailboxListView === dic.CONSTANTS.mailboxListViews.domains && {text:'Domain', sortKey:'domainName'},
				{text:'Name', sortKey:'name'},
				{text:'Email', sortKey:'email'},
				{text:'Status', sortKey:'status', width: '150px'},
				{text:'Mail Server license', sortKey: 'license', width: '190px', tooltip: 'The license type associated to this mailbox on O365/Exchange/Google. This column is not related to the Trustifi license.'},
				{text:'Last Email', sortKey: 'last_email_priority'},
			])"
			[cellsPrototype]="_.compact([
				mailboxListView === dic.CONSTANTS.mailboxListViews.domains && {html: 'domainNameCell', overflowOutside: true},
				{html: 'nameCell'},
				{html: 'emailAddressCell'},
				{html: 'statusCell'},
				{html: 'licenseCell'},
				{html: 'lastEmailCell'},
			])"
			[bulkActions] = "{
				enable: true,
				selectBulkActionCb:	selectMultipleMailboxesAction,
				initBulkActionsFunction: showMultipleMailboxesActions,
				showInRed: {enable: true, terms: ['Delete Mailbox']}
			}"
			[cellActions] = "{
				enable: true,
				selectItemActionCb:	selectMailboxAction,
				initActionsFunction: showMailboxActions,
				showInRed: {enable: true, terms: ['Delete Mailbox']}
			}"
			(searchFunction)="searchMailbox($event.searchTerm, $event.activeFilters)"
			[filterData]="filterData"
			[subRowOptions]="{
				recursionKey: 'mailboxes',
				allowActions: true
			}"
			[options]="{
				itemsNameSingular: 'user',
				exportToCsvFunction: exportMailboxesCsv,
				defaultSortKey: mailboxListView === dic.CONSTANTS.mailboxListViews.all ? '-is_protected' : '-domainName',
				loadingTableFlag: loadingInProcess,
				itemUniqueIdentifier: '_id',
				changeTableViewMenu: {
					all: {label: 'View per mailbox', action: updateListView},
					domains: {label: 'View per domain', action: updateListView},
				}
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<!--domain name cell-->
				<span *ngIf="cellId === 'domainNameCell'">
					<div class="flex-row gap-1" style="align-items: center; cursor: pointer; position: absolute; left: 10px; top: 50%; transform: translateY(-50%);"
						 *ngIf="item.isDomainTitleRecord"
						 (click)="toggleExpandItem(item, $event); mailboxesTable.searchItem();">
						<i class="far fa-chevron-right" style="color: royalblue; transition: transform 0.15s ease-out; padding: 5px; padding-left: 0;"
						   *ngIf="item.mailboxes && item.displayedCounter"
						   [ngStyle]="{'transform' : item.isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'}"></i>
						<span>{{item.domainName}}</span>
						<span style="opacity: 0.75;">({{item.displayedCounter}} mailbox{{item.displayedCounter > 1 ? 'es': ''}})</span>
					</div>
				</span>
				<!--name cell-->
				<span *ngIf="cellId === 'nameCell' && !item.isDomainTitleRecord">
					<div class="flxRow hSpace05" style="align-items: center; cursor: pointer;">
						<img [src]="'https://gravatar.com/avatar/' + gs.stringToSha256(item.email)+ '?s=30&d=mp'" style="border-radius: 50%;" width="30" height="30" alt="By Gravatar"/>
						<i class="far fa-user-check" style="color: green;" tooltip="Personal reviewer" *ngIf="item.is_personal_reviewer"></i>
						<i class="far fa-mail-bulk" style="color: green;" tooltip="Subscription Bombing Protection is active: sign-up and confirmation floods from unfamiliar senders are tagged as Graymail" *ngIf="item.subscription_bombing"></i>
						<span style="vertical-align: middle;">{{item.name || 'N/A'}}</span>
					</div>
				</span>
				<!--email cell (job role shown as a secondary line)-->
				<span *ngIf="cellId === 'emailAddressCell' && !item.isDomainTitleRecord">
					<div class="flex-column">
						<span class="ellipsis" [tooltip]="item.email">{{item.email}}</span>
						<div class="flex-row gap-1 align-items-center text-muted" style="font-size: 11.5px;" *ngIf="item.job_title || item.is_executive">
							<i class="far fa-user-tie" *ngIf="item.is_executive" style="color: green;" tooltip="Executive Role"></i>
							<span class="ellipsis" [tooltip]="item.job_title">{{item.job_title}}</span>
						</div>
					</div>
				</span>
				<!--status cell-->
				<span *ngIf="cellId === 'statusCell' && !item.isDomainTitleRecord">
					<span [ngClass]="item.status === dic.CONSTANTS.inboundMailBoxStatus.protect ? 'text-success' : 'text-danger'">
						{{item.status + (item.is_protected && item.protectedType ? ' (' + item.protectedType + ')' : '')}}
					</span>
					<i class="far fa-question-circle opacity-75" *ngIf="item.statusToolip"
					   [tooltip]="item.statusToolip"></i>
				</span>
				<!--license cell-->
				<span *ngIf="cellId === 'licenseCell' && !item.isDomainTitleRecord">
					{{item.license || 'N/A'}}
				</span>
				<!--last email cell-->
				<span *ngIf="cellId === 'lastEmailCell' && !item.isDomainTitleRecord">
					<span [ngClass]="{'text-muted' : !item.last_email}">{{item.last_email ? (item.last_email | date:'MM/dd/yyyy HH:mm') : 'None'}}</span>
				</span>
			</ng-template>
			<div tableButtons>
				<div class="flex-row gap-1 align-items-center">
					<app-dropdown-c style="width: 150px; height: 32px;" text="API Protection"
									[isLf]="true"
									[isDisabled]="!subscriptionUsers.length || !mailServerConnected">
						<li (click)="selectMultipleMailboxesAction(subscriptionUsers, dic.CONSTANTS.inboundMailboxAction.enable.display)">
							Protect All
						</li>
						<li (click)="openProtectGroupsPopup(true);">
							Protect Groups
						</li>
						<li (click)="enableApiProtection(subscriptionUsers, {limitedMailboxes: true})">
							Protect Licensed Mailboxes
						</li>
						<li ngfSelect
							[(file)]="mailboxesFile"
							accept=".csv"
							(fileChange)="protectMailboxesFromCsv(mailboxesFile)">
							Protect From CSV
						</li>
					</app-dropdown-c>
					<btn-c style="width: 150px;"
						   [loading]="{flag: loadingInProcess, text: 'Sync Mailboxes'}"
						   [isDisabled]="loadingInProcess || !mailServerConnected"
						   (action)="getMailboxesRefresh();"
						   startIcon="far fa-sync">
						Sync Mailboxes
					</btn-c>
					<app-dropdown-c style="width: 150px; height: 32px;" text="More" [isLf]="true">
						<li (click)="getGroups(true)">
							Show Groups
						</li>
						<li (click)="getMailboxesAliases(true)">
							Show Aliases
						</li>
					</app-dropdown-c>
				</div>
			</div>
		</trustifi-table-c>
    </div>


	<popup-c *ngIf="inviteUserPopup?.show"
			 [head]="inviteUserPopup.title" class="bs-enabled"
			 (closeCb)="inviteUserPopup = null;" width="500px"
			 (confirmCb)="inviteUserPopup?.doneCb();"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', disabled: inviteUserPopup.inProcess}}" size="dynamic">
		<div class="flex-column f-1-0">
			<span>An invite will be sent via email to {{inviteUserPopup.mailboxes.length > 1 ? 'the selected users' : inviteUserPopup.mailboxes[0].email}}.</span>
			<span>When they sign up using the invite they will automatically join your plan with admin-level permissions.</span>
		</div>
	</popup-c>

	<!--Set Mailbox as Alias popup-->
	<popup-c *ngIf="mailboxAliasPopup?.show"
			 head="Set Mailbox as Alias"
			 (closeCb)="mailboxAliasPopup = null;"
			 (confirmCb)="mailboxAliasPopup.doneCb();"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', disabled: mailboxAliasPopup.inProcess}}" size="dynamic">
		<div class="flxClmn vSpace3 f-1-0" style="overflow: auto;">
			<span>This mailbox will be removed, and set as an alias for a different mailbox.<br>All emails sent to this alias will arrive at the mailbox specified below.</span>
			<span>Please specify which mailbox this address should be an alias for:</span>
			<input id="mailboxAlias" type="text" placeholder="mailbox" style="margin: 0; width: 300px; box-sizing: inherit;"
				   [(ngModel)]="mailboxAliasPopup.aliasInput" />
		</div>
	</popup-c>

    <!--Set Mailbox Settings popup-->
    <popup-c class="bs-enabled"  *ngIf="changeUserSettingsPopup?.show"
			 head="Change Mailbox Settings" subTitle="Update mailbox {{changeUserSettingsPopup.mailbox.email}}"
           (closeCb)="changeUserSettingsPopup = null;"
			size="medium">
		<div class="flxClmn f-1-0" style="overflow: auto;">

			<div class="simple-tab-row w100 flxRow">
				<ng-container *ngFor="let tab of changeUserSettingsPopup.tabs | keyvalue: gs.returnZero">
					<div class="tab-header"
						 [ngClass]="{'chosen' : changeUserSettingsPopup.activeTab === tab.value}"
						 (click)="changeUserSettingsPopup.activeTab = tab.value">
						<span class="hvr-opacity">{{tab.value}}</span>
					</div>
				</ng-container>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="changeUserSettingsPopup.activeTab === changeUserSettingsPopup.tabs.general">
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 2.8 0;">
						<b>Job Title</b>
						<span class="lh-base" style="font-size: 0.9em;">The job title will be displayed for this mailbox</span>
					</div>
					<div class="content-container p-0">
						<div *ngIf="!changeUserSettingsPopup.editJobTitle" class="flex-column gap-1">
							<div class="flex-row gap-2">
								<span>{{changeUserSettingsPopup.mailbox.job_title || 'N/A'}}</span>
								<i class="far fa-edit" style="cursor: pointer;" (click)="changeUserSettingsPopup.editJobTitle = {name: changeUserSettingsPopup.mailbox.job_title, is_executive: changeUserSettingsPopup.mailbox.is_executive }"></i>
							</div>
							<checkbox id="is_executive" [(model)]="changeUserSettingsPopup.mailbox.is_executive" [isDisabled]="true">
								Executive
							</checkbox>
						</div>

						<div *ngIf="changeUserSettingsPopup.editJobTitle" class="flex-column gap-1">
							<div class="flex-row gap-2">
								<input class="f-1-0" style="min-width: 0;" type="text" placeholder="Job"
								   [(ngModel)]="changeUserSettingsPopup.editJobTitle.name"/>
								<btn-c style="min-width: 0;" endIcon="zmdi zmdi-check"
									   [isDisabled]="!changeUserSettingsPopup.editJobTitle.name || changeUserSettingsPopup.inProcess"
									   (action)="updateMailboxJobTitle(changeUserSettingsPopup.mailbox, changeUserSettingsPopup.editJobTitle);">
								</btn-c>
								<btn-c style="min-width: 0;"
									   endIcon="zmdi zmdi-close" color="danger"
									   variant="text"
									   btnTooltip="Cancel edit"
									   (action)="changeUserSettingsPopup.editJobTitle = null;">
								</btn-c>
							</div>

							<checkbox id="is_executive" [(model)]="changeUserSettingsPopup.editJobTitle.is_executive">
								Executive
							</checkbox>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 2.8 0;">
						<b>Notification Options</b>
						<span class="lh-base" style="font-size: 0.9em;">
							Select the notification timing on quarantined emails
						</span>
					</div>
					<div class="content-container p-0">
						<div *ngIf="!changeUserSettingsPopup.editNotificationSched">
							<div class="flex-column gap-1">
								<div class="flex-row gap-1">
									<span>{{changeUserSettingsPopup.mailbox.notify_reviewer_periods.join(', ').replace('Notify every day', 'Custom notification times') || 'N/A'}}</span>
									<i class="far fa-edit" style="cursor: pointer;" (click)="changeUserSettingsPopup.editNotificationSched = true"></i>
								</div>
								<span *ngIf="changeUserSettingsPopup.mailbox.notify_reviewer_days?.length && changeUserSettingsPopup.mailbox.notify_reviewer_periods.includes('Notify every day')">{{changeUserSettingsPopup.mailbox.notify_reviewer_days.join(', ')}}</span>
							</div>
						</div>

						<div class="flex-column gap-2" *ngIf="changeUserSettingsPopup.editNotificationSched">

							<div class="flxRow hSpace1" style="align-items: center; z-index: 50;">
								<span style="flex-basis: 150px; flex-shrink: 0;">Notification timing:</span>
								<div style="flex: 1 0; position: relative;">
									<app-dropdown-c style="width: 250px; min-width: 100%;"
													[error]="changeUserSettingsPopup.notificationSched.isNotifyReviewerPeriodsError"
													text="{{changeUserSettingsPopup.notificationSched.periods && _.keys(_.pickBy(changeUserSettingsPopup.notificationSched.periods)).join(', ').replace('Notify every day', 'Custom notification times') || 'Select'}}">
										<li *ngFor="let periodKey of dic.CONSTANTS.tpRule.notifyOptions | keyvalue: gs.returnZero"
											(click)="changeUserSettingsPopup.notificationSched.periods[periodKey.value] = !changeUserSettingsPopup.notificationSched.periods[periodKey.value]; changeUserSettingsPopup.notificationSched.isNotifyReviewerPeriodsError = false; $event.stopPropagation();"
											id="{{'notifyReviewerPeriod_' + periodKey.key}}">
											<checkbox (click)="$event.preventDefault();"
													  [(model)]="changeUserSettingsPopup.notificationSched.periods[periodKey.value]">
												{{periodKey.value === dic.CONSTANTS.tpRule.notifyOptions.everyDay ? 'Custom notification times' : periodKey.value}}
											</checkbox>
										</li>
									</app-dropdown-c>
									<span style="position: absolute; bottom: -20px; right: 0;  font-size: 12px; color: red;"
										  *ngIf="changeUserSettingsPopup.notificationSched.isNotifyReviewerPeriodsError">
											required field
									</span>
								</div>
							</div>

							<div class="flxRow hSpace1 animated fadeIn" style="align-items: center; z-index: 40;"
								 *ngIf="changeUserSettingsPopup.notificationSched.periods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
								<span style="flex-basis: 150px;">Notification days:</span>
								<div style="position: relative; flex: 1 0;">
									<app-dropdown-c style="width: 250px; --bs-dropdown-max-height: 150px; --bs-dropdown-overflow: auto; min-width: 100%;"
													[error]="changeUserSettingsPopup.notificationSched.isNotifyReviewerDaysError"
													[hideCounter]="true"
													[text]="_.map(_.filter(changeUserSettingsPopup.notificationSched.notifyReviewerDays, 'selected'),'day').join(', ') || 'Select'">
										<li *ngFor="let dayModel of changeUserSettingsPopup.notificationSched.notifyReviewerDays"
											(click)="dayModel.selected = !dayModel.selected; $event.stopPropagation();"
											id="{{'notifyReviewerDay_' + ''}}">
											<checkbox (click)="$event.preventDefault();" [model]="dayModel.selected">
												{{dayModel.day}}
											</checkbox>
										</li>
									</app-dropdown-c>
									<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
										  *ngIf="changeUserSettingsPopup.notificationSched.isNotifyReviewerDaysError">
											required field
									</span>
								</div>
							</div>

							<div class="flxRow hSpace1 animated fadeIn w100" style="align-items: center; z-index: 39;"
								 *ngIf="changeUserSettingsPopup.notificationSched.periods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
								<span style="flex-basis: 150px;">Notification hours:</span>
								<div style="position: relative; flex: 1 0;">
									<app-dropdown-c style="width: 250px; --bs-dropdown-max-height: 150px; --bs-dropdown-overflow: auto; min-width: 100%;"
													[error]="changeUserSettingsPopup.notificationSched.isNotifyReviewerDailyHoursError"
													text="{{gs.getDailyHoursText(changeUserSettingsPopup.notificationSched.dailyHours) || 'Select'}}">
										<li *ngFor="let twoDigitHour of gs.hoursArr"
											(click)="toggleNotificationDailyHour(changeUserSettingsPopup.notificationSched.dailyHours, twoDigitHour); $event.stopPropagation();"
											id="{{'notifyReviewerDailyHour_' + twoDigitHour}}">
											<checkbox (click)="$event.preventDefault();"
													  [model]="changeUserSettingsPopup.notificationSched.dailyHours.includes(twoDigitHour)">
												{{twoDigitHour + ':00'}}
											</checkbox>
										</li>
									</app-dropdown-c>
									<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
										  *ngIf="changeUserSettingsPopup.notificationSched.isNotifyReviewerDailyHoursError">
											required field
									</span>
								</div>
							</div>

							<div *ngIf="!planInfo.threat_protection.rules.notify_recipient_allow_change_time">
								<checkbox id="notify_recipient_allow_change_time" [(model)]="changeUserSettingsPopup.notificationSched.notifyRecipientAllowChangeTime">
									Allow users to set their own custom notification times
								</checkbox>
							</div>

							<div class="flex-row align-items-center mt-3 gap-2">
								<btn-c style="min-width: 0;"
									   [isDisabled]="changeUserSettingsPopup.inProcess"
									   (action)="changeNotifyPeriod();">
									Confirm
								</btn-c>

								<btn-c style="min-width: 0;" variant="outlined"
									   (action)="changeUserSettingsPopup.editNotificationSched = null;">
									Cancel
								</btn-c>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="changeUserSettingsPopup.activeTab === changeUserSettingsPopup.tabs.scanMetrics">
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Check Impersonation</b>
						<span class="lh-base" style="font-size: 0.9em;">Check incoming emails for impersonation of this user's contacts</span>
					</div>
					<div class="content-container overflow-auto pt-1">
						<toggle-switch-c id="check_impersonation"
										 [hideText]="true"
										 [(model)]="changeUserSettingsPopup.mailbox.check_impersonation"
										 (onChange)="setCheckImpersonationForMailbox(changeUserSettingsPopup.mailbox)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Scan for Threat AI</b>
						<span class="lh-base" style="font-size: 0.9em;">Scan incoming emails using AI to detect Business Email Compromise (BEC) attacks. For support/IT mailboxes or any mailboxes that handle sensitive content from unknown senders it is recommended to disable this metric</span>
					</div>
					<div class="content-container overflow-auto pt-1">
						<toggle-switch-c id="scan_threat_ai"
										 [hideText]="true"
										 [(model)]="changeUserSettingsPopup.mailbox.scan_threat_ai"
										 (onChange)="setScanThreatAIForMailbox(changeUserSettingsPopup.mailbox)"></toggle-switch-c>
					</div>
				</div>

				<!--TODO: temporary gate (EMDR security reviewer or this plan only). Remove the *ngIf to enable for all clients-->
				<div class="list-group-item settings-list-item py-4" *ngIf="userInfo?.is_security_reviewer || changeUserSettingsPopup.mailbox.plan_id === subscriptionBombingPlanId">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Subscription Bombing Protection</b>
						<span class="lh-base" style="font-size: 0.9em;">Detect subscription bombing attacks, where a mailbox is flooded with sign-up, registration, activation, verification, welcome or confirmation emails to bury a real attack (such as a password reset or fraudulent transaction alert). Matching emails from unfamiliar senders will be tagged as <b>Graymail</b> with the sub-status <b>Subscription Bombing</b>. Trusted and known senders are not affected</span>
					</div>
					<div class="content-container overflow-auto pt-1">
						<toggle-switch-c id="subscription_bombing"
										 [hideText]="true"
										 [(model)]="changeUserSettingsPopup.mailbox.subscription_bombing"
										 (onChange)="setSubscriptionBombingForMailbox(changeUserSettingsPopup.mailbox)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Count as Licensed Mailbox</b>
						<span class="lh-base" style="font-size: 0.9em;">This mailbox will be included in your license usage and billed accordingly</span>
					</div>
					<div class="content-container overflow-auto pt-1">
						<toggle-switch-c id="billable"
										 [hideText]="true"
										 [(model)]="changeUserSettingsPopup.mailbox.billable"
										 (onChange)="setMailboxBillableExecute(changeUserSettingsPopup.mailbox, changeUserSettingsPopup.mailbox.billable)"></toggle-switch-c>
					</div>
				</div>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="changeUserSettingsPopup.activeTab === changeUserSettingsPopup.tabs.personalReviewer">
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Personal Reviewer</b>
						<span class="lh-base" style="font-size: 0.9em;">Personal reviewers will always be allowed to review and release/remove their quarantined emails</span>
					</div>
					<div class="content-container overflow-auto pt-1">
						<toggle-switch-c id="allow_reviewers"
										 [hideText]="true"
										 [(model)]="changeUserSettingsPopup.mailbox.is_personal_reviewer"
										 (onChange)="updatePersonalReviewer(changeUserSettingsPopup.mailbox)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Release Malicious Emails</b>
						<span class="lh-base" style="font-size: 0.9em;">Allow this reviewer to release malicious emails</span>
					</div>
					<div class="content-container overflow-auto pt-1">
						<toggle-switch-c id="allow_admins"
										 [hideText]="true"
										 [isDisabled]="!changeUserSettingsPopup.mailbox.is_personal_reviewer"
										 [(model)]="changeUserSettingsPopup.mailbox.reviewer_allow_release_malicious"
										 (onChange)="updatePersonalReviewer(changeUserSettingsPopup.mailbox)"></toggle-switch-c>
					</div>
				</div>
			</div>

			<div class="list-group list-group-flush settings-list-container" *ngIf="changeUserSettingsPopup.activeTab === changeUserSettingsPopup.tabs.viewContentPermission">
				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Reviewers</b>
						<span class="lh-base" style="font-size: 0.9em;">All inbound reviewers will be able to view quarantined email content for this mailbox</span>
					</div>
					<div class="content-container overflow-auto pt-1">
						<toggle-switch-c id="allow_reviewers"
										 [hideText]="true"
										 [(model)]="changeUserSettingsPopup.mailbox.view_content.allow_reviewers"
										 (onChange)="setViewContentPermissionReviewers(changeUserSettingsPopup.mailbox)"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-4">
					<div class="title-section-container flex-column gap-2" style="flex: 6 0;">
						<b>Admin</b>
						<span class="lh-base" style="font-size: 0.9em;">All plans admins will be able to view quarantined email content for this mailbox</span>
					</div>
					<div class="content-container overflow-auto pt-1">
						<toggle-switch-c id="allow_admins"
										 [hideText]="true"
										 [(model)]="changeUserSettingsPopup.mailbox.view_content.allow_admins"
										 (onChange)="setViewContentPermissionAdmins(changeUserSettingsPopup.mailbox)"></toggle-switch-c>
					</div>
				</div>

			</div>

		</div>
    </popup-c>

	<!--Enable API protection-->
	<popup-c *ngIf="showEnableApiProtectionPopup?.show"
			 head="Enable API Protection"
			 subTitle="Enable Inbound Shield API protection"
			 (closeCb)="showEnableApiProtectionPopup = null;"
			 (confirmCb)="enableApiProtectionExecute();"
			 [buttons]="{cancel: 'Cancel', confirm: 'Protect'}" size="dynamic">
		<div class="flxClmn vSpace3 f-1-0">
			<span>
				If you are connected through Email Relay or via MX record, there is no need to manually enable protection. The system will automatically activate protection when the mailbox receives an email.
			</span>

			<div *ngIf="!planInfo.exchange_server?.contacts_enabled">
				<checkbox id="enableDefault" [(model)]="showEnableApiProtectionPopup.importContacts">
					Allow importing contacts
				</checkbox>
				<span>Importing user contacts from Exchange is highly recommended to help prevent contact impersonation attacks.</span>
			</div>

			<div *ngIf="showEnableApiProtectionPopup.showLimitedMailboxes" class="flxRow hSpace1" style="align-items: center;">
				<span>Enable protection for:</span>
				<input style="text-align: center; width: 60px;" type="number" min="1" step="1" pattern="^\d*(\.\d{0,10})?$" placeholder="Mailboxes"
					   [(ngModel)]="showEnableApiProtectionPopup.limitedMailboxes">
				<span><b>licensed</b> mailboxes.</span>
			</div>
		</div>
	</popup-c>


    <aliases-popup-c *ngIf="showAliases"
               (cancelCb)="getMailboxesAliases(false)"
               [popupTitle]="'Mailboxes Aliases'"
               [showActions]="true">
    </aliases-popup-c>

    <groups-popup-c *ngIf="showGroups"
                (cancelCb)="getGroups(false)"
                [popupTitle]="'Groups'"
                [showActions]="true">
    </groups-popup-c>

    <groups-popup-c
            *ngIf="showProtectGroups"
            (cancelCb)="openProtectGroupsPopup(false)"
            (doneCb)="applyProtectGroupsPopup($event.groups)"
            [doneBtnTxt]="'Protect'"
            [multipleSelection]="true"
            [popupTitle]="'Protect Groups'"
            [popupSubTitle]="'Select groups to enable API protection. the action will be applied for all group members'">
    </groups-popup-c>
</div>


